import { AppRouteProps } from "@harea/component";
import DebauchageContainer from "./container/DebauchageContainer";

export const DebauchageRoutes: Array<AppRouteProps> = [
  {
    path: "debauchage",
    element: <DebauchageContainer />,
  },
];
